import { render, staticRenderFns } from "./courseDetailsVideo.vue?vue&type=template&id=1dca8a16&"
import script from "./courseDetailsVideo.vue?vue&type=script&lang=js&"
export * from "./courseDetailsVideo.vue?vue&type=script&lang=js&"
import style0 from "./courseDetailsVideo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports